export const SET_WALLET_ISSUE_DATA = "SET_WALLET_ISSUE_DATA";
export const SET_WALLET_ISSUE_PAGINATION = "SET_WALLET_ISSUE_PAGINATION";
export const RESET_WALLET_ISSUE_REDUCER = "RESET_WALLET_ISSUE_REDUCER";
